export const isMfaCancelledError = (error: unknown) => {
  return error instanceof Error && error.message === "MFA canceled"
}
